import { makeChainAddressId } from '@infinex/asset-config';

import { toCustodySelected } from './gas-dialog-screens/GasAssetSelector';
import { useGasDeposit } from './GasDepositQuoteProvider';

import { AssetSourceSelectList } from '../asset-select/AssetSourceSelectList';
import type { AssetSelection } from '../asset-select/type';
import { useCustodySelection } from '../wallet-selector/WalletSelectedProvider';

export function GasAssetSourceScreen({
  asset,
  onComplete,
}: {
  asset: AssetSelection;
  onComplete: () => void;
}) {
  const { setSelected } = useCustodySelection();
  const {
    assetSelection: { setSelectedChainId },
  } = useGasDeposit();

  return (
    <AssetSourceSelectList
      asset={asset}
      onSelectAssetSource={(id) => {
        const custodySelected = toCustodySelected(id);
        if (custodySelected) {
          setSelected(custodySelected);
        }
        setSelectedChainId(makeChainAddressId(asset.chain, asset.address));
        onComplete();
      }}
    />
  );
}
